import React, {Fragment} from 'react'
import yn from 'yn'
import _ from 'lodash'
import editStayIcon from '../../../../assets/icons/edit-stay.svg'

import moment from "moment/moment";

const BkFlowNavigationPropertyDetails = props =>  {
	const {
		availabilityData,
		configData,
		toggleEditModal,
		urlData,
	} = props

	const hotelLabels = configData.hotel.labels[0]

	let activeHotelCode = null
	let matchedProperty = null

	if (
		!_.isEmpty(urlData) &&
		urlData.hotelCode
	) {
		activeHotelCode = urlData.hotelCode
	}

	if (!_.isEmpty(configData)) {
		const configProperties = configData.hotel.options.properties

		matchedProperty = configProperties.find(function (property) {
			return property.hotelCode === String(activeHotelCode)
		})
	}

	let activeHotel = null

	if (
		!_.isEmpty(availabilityData) &&
		_.get(availabilityData, '[0][0].basicPropertyInfo')
	) {
		if (_.get(availabilityData, '[0][0].basicPropertyInfo.hotelName')) {
			activeHotel = availabilityData[0][0].basicPropertyInfo.hotelName
		}
	}

	let propertyAddress = null
	let propertyNumbers = null

	if (matchedProperty) {
		if (matchedProperty.address) {
			propertyAddress = matchedProperty.address
		}

		if (matchedProperty.contactNumbers) {
			propertyNumbers = matchedProperty.contactNumbers
		}
	}

	return  (
		<div className="bk-flow-navigation__mobile-details">
			<h6
				id="bk-toggle-edit-stay u-remove-margin"
				tabIndex={0}
				onClick={() => toggleEditModal()}
			>
				{activeHotel ? activeHotel : '--'}
				<img src={editStayIcon} alt="Edit Stay Details" />
			</h6>

			{ propertyAddress &&
				<p className="mobile-details-address">
					{ propertyAddress &&
						propertyAddress.addressLine &&
						propertyAddress.addressLine[0] &&
						<span className="label-address">{propertyAddress.addressLine[0]}</span>
					}
					{propertyAddress.cityName && <span className="label-city">&nbsp;{propertyAddress.cityName},</span>}
					{propertyAddress.countryName && <span className="label-country">&nbsp;{propertyAddress.countryName}</span>}
					{propertyAddress.postalCode && <span className="label-postal-code">&nbsp;{propertyAddress.postalCode}</span>}
				</p>
			}

			{urlData && (urlData.startDate || urlData.endDate) &&
				<p className="mobile-details-reservation-dates">
					{urlData.startDate &&
					<span>{moment(urlData.startDate).format('Do MMM YYYY')}</span>
					}

					{urlData.endDate &&
					<Fragment>
						<i className="material-icons">east</i>
						<span>{moment(urlData.endDate).format('Do MMM YYYY')}</span>
					</Fragment>
					}
				</p>
			}

			{ yn(process.env.REACT_APP_COMPONENT_ENABLE_RESERVATIONS_PHONE) &&
				propertyNumbers &&
				propertyNumbers.reservations &&
				<p className="mobile-details-reservations-phone">
					<span className="phone-label">{hotelLabels & hotelLabels.reservationsPhone ? hotelLabels.reservationsPhone : 'Reservations'}:&nbsp;</span>
					<a href={'tel:' + propertyNumbers.reservations} className="phone-value">{propertyNumbers.reservations}</a>
				</p>
			}

			{  yn(process.env.REACT_APP_COMPONENT_ENABLE_PROPERTY_PHONE) &&
				propertyNumbers &&
				propertyNumbers.property &&
				<p className="mobile-details-property-phone">
					<span className="phone-label">{hotelLabels & hotelLabels.propertyPhone ? hotelLabels.propertyPhone : 'Property'}:&nbsp;</span>
					<a href={'tel:' + propertyNumbers.property} className="phone-value">{propertyNumbers.property}</a>
				</p>
			}
		</div>
	)
}

export default BkFlowNavigationPropertyDetails


// WEBPACK FOOTER //
// ./src/components/structure/navigation/mobile/BkFlowNavigationPropertyDetails.js